export default __webpack_public_path__ + "static/media/SM_logo_blue.817983ec.svg";